import styled, { css } from 'styled-components'

import { MEDIA_QUERY } from '../../../styles'

export const Container = styled.div``

export const Items = styled.ul<{ $useGrid?: boolean; $gridSize?: number }>`
  display: inline-flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
  outline-offset: 2px;
  ${({ $useGrid, $gridSize }) =>
    $useGrid &&
    css`
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(${$gridSize ? `${$gridSize}px` : '120px'}, 1fr));
    `};
  @media ${MEDIA_QUERY.MOBILE} {
    justify-content: flex-start;
  }
`
